// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 策略包详情 GET /strategy-package/info */
export async function strategyPackageInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyPackageInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyPackageInfoResp>('/strategy-package/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略包列表 GET /strategy-package/list */
export async function strategyPackageListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyPackageListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyPackageSimpleResp>('/strategy-package/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
